import { cn } from '@/lib/utils';
import Dot from '@/components/ui/Dot.tsx';
import { columnLabelClass } from '@/components/ui/typography.ts';

/**
 * Nagłówek karty szkicu. Ta sama etykieta wersalikowa, co w pozostałych
 * kartach panelu, tylko w `ink` zamiast szarości — karta szkicu jest jedyną
 * żywą kartą w edycji i tytuł ma to nieść razem z kropką.
 */
const DraftCardHeader = () => (
  <div className="flex items-center gap-2.5 border-b border-accent-border px-5 py-4">
    <Dot />
    <span className={cn(columnLabelClass, 'text-ink')}>Szkic paczki zmian</span>
  </div>
);

export default DraftCardHeader;
